const ApiErrors = {
  invalid_reading:
    "The reading you have entered is invalid. Please check the meter reading again and enter the correct reading.",
};

export const showApiAlert = (status, message) => {
  const errorMessage = ApiErrors[message];
  let title = "Info",
    type = "";
  switch (status) {
    case 400:
      title = "Bad request";
      type = "warning";
      break;
    case 500:
      title = "Something went wrong";
      type = "error";
      break;
  }

  global.showAlert(title, errorMessage || message, type);
};
